<template>
  <moe-page>
    <moe-top ref="moeTop"></moe-top>
    <div class="paper_tab flex Flexjustify">
      <div class="paper_tab_list flex Flexalign">
        <div class="paper_tab_one mr-20 cursor_pointer" v-for="(item, index) in paperTypeTabList" :key="index"
          :class="[selectPaperTypeTab == item.value ? 'paper_tab_one_active' : '']" @click="changePaperType(item)">
          <div>{{ item.label }}</div>
          <div class="active_line" v-if="selectPaperTypeTab == item.value"></div>
        </div>
      </div>
    </div>
    <div class="test_paper_content flex Flexjustify" v-if="selectPaperTypeTab == 1">
      <div class="content flex FlexBetween">
        <div class="content_left">
          <div class="catalog_details flex Flexalign p-10">
            <el-image class="catalog_details_icon" :src="iconPath('catalog_details_icon.png')"></el-image>
            <div class="ml-5">
              {{
                paperTypeTabList.filter((item) => item.value == selectPaperTypeTab)[0]
                  ?.label
              }}
            </div>
          </div>
          <div class="p-15 tree_box px-30">
            <div class="education_one cursor_pointer" v-for="(item, index) in educationData" :key="index"
              :class="[selectEducation == item.value ? 'education_one_active' : '']" @click="changeEducation(item)">
              {{ item.label }}
            </div>
          </div>
        </div>
        <div class="content_right mb-30 scroll_y hidden_scroll" ref="rightScrollContainer">
          <!-- 筛选条件区域 -->
          <div class="right_top p-20" ref="filterRef">
            <div class="filter_box flex mb-20">
              <div class="filter_label">类型：</div>
              <div class="filter_list flex FlexWrap flex-1">
                <div class="filter_value ml-30 cursor_pointer" v-for="(item, index) in paperTypeList" :key="index"
                  :class="[listParams.feeType == item.value ? 'text_active' : '']" @click="selectPaperType(item)">
                  {{ item.label }}
                </div>
              </div>
            </div>
            <div class="filter_box flex mb-20">
              <div class="filter_label">学段：</div>
              <div class="filter_list flex FlexWrap flex-1">
                <div class="ml-30 area_info cursor_pointer" :class="[listParams.stageId == '' ? 'text_active' : '']"
                  @click="selectStage('')">
                  不限
                </div>
                <div class="filter_value ml-30 cursor_pointer" v-for="(item, index) in stageList" :key="index"
                  :class="[listParams.stageId == item.stageId ? 'text_active' : '']" @click="selectStage(item.stageId)">
                  {{ item.stageName }}
                </div>
              </div>
            </div>
            <div class="filter_box flex mb-20">
              <div class="filter_label">年级：</div>
              <div class="filter_list flex FlexWrap flex-1">
                <div class="ml-30 area_info cursor_pointer" :class="[listParams.gradeId == '' ? 'text_active' : '']"
                  @click="selectGrade('')">
                  不限
                </div>
                <div class="filter_value ml-30 cursor_pointer" v-for="(item, index) in gradeList" :key="index"
                  :class="[listParams.gradeId == item.gradeId ? 'text_active' : '']" @click="selectGrade(item.gradeId)">
                  {{ item.gradeName }}
                </div>
              </div>
            </div>
            <div class="filter_box flex">
              <div class="filter_label">学科：</div>
              <div class="filter_list flex FlexWrap flex-1">
                <div class="ml-30 area_info cursor_pointer" :class="[listParams.subjectId == '' ? 'text_active' : '']"
                  @click="selectSubject('')">
                  不限
                </div>
                <div class="filter_value ml-30 cursor_pointer" v-for="(item, index) in subjectList" :key="index"
                  :class="[listParams.subjectId == item.subjectId ? 'text_active' : '']"
                  @click="selectSubject(item.subjectId)">
                  {{ item.subjectName }}
                </div>
              </div>
            </div>
            <div class="filter_box flex mt-15 Flexalign">
              <div class="filter_label">更多：</div>
              <div class="filter_list flex FlexWrap flex-1">
                <el-select class="ml-30" v-model="listParams.year" placeholder="年份" style="width: 100px"
                  @change="getExaminationList">
                  <el-option v-for="item in yearOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
                <el-select class="ml-30" v-model="listParams.difficulty" placeholder="难易度" style="width: 100px"
                  @change="getExaminationList">
                  <el-option v-for="item in difficultOptions" :key="item.value" :label="item.label"
                    :value="item.value" />
                </el-select>
                <el-select class="ml-30" v-model="listParams.roundId" placeholder="轮次" style="width: 100px"
                  @change="getExaminationList">
                  <el-option v-for="item in planOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
                <el-select class="ml-30" v-model="listParams.phaseId" placeholder="阶段" style="width: 100px"
                  @change="getExaminationList">
                  <el-option v-for="item in phaseOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </div>
            </div>
          </div>

          <!-- 试卷列表区域 -->
          <div class="right_bottom mt-20 px-15 pb-20" ref="bottomRef">
            <div class="" v-if="testPaperList.length">
              <!-- 排序选项卡 -->
              <div class="sort-tab">
                <div class="flex Flexalilgn FlexBetween">
                  <div class="select_box mb-10 flex Flexalign">
                    <div class="filter_text cursor_pointer" :class="[listParams.sort == 1 ? 'text_active' : '']"
                      @click="changeFilter(1)">最新</div>
                    <div class="filter_text ml-30 cursor_pointer" :class="[listParams.sort == 2 ? 'text_active' : '']"
                      @click="changeFilter(2)">浏览量</div>
                    <div class="filter_text ml-30 cursor_pointer" :class="[listParams.sort == 3 ? 'text_active' : '']"
                      @click="changeFilter(3)">下载量</div>
                  </div>
                  <div class="total_num">共计 {{ listTotal }} 套</div>
                </div>
              </div>

              <!-- 试卷列表 - 可滚动区域 -->
              <div class="test_paper_list hidden_scroll" ref="paperListRef">
                <div class="test_paper_one pb-10 mb-15 flex Flexalign Flexbetween cursor_pointer"
                  v-for="(item, index) in testPaperList" :key="index" @click="viewExamPaper(item)">
                  <el-image class="test_paper_cover_icon" :src="iconPath('test_paper_cover_icon.svg')"></el-image>
                  <div class="paper_info flex flexcolumn ml-15">
                    <div class="toverflow paper_name">{{ item.paperDocumentName }}</div>
                    <div class="paper_tag flex mt-15">
                      <div class="tag_one px-10 py-5 mr-10">
                        {{
                          gradeList.filter((sitem) => sitem.stageId == item.stageId)[0]
                            ?.stageName
                        }}
                      </div>
                      <div class="tag_one px-10 py-5 mr-10">
                        {{
                          gradeList.filter((sitem) => sitem.gradeId == item.gradeId)[0]
                            ?.gradeName
                        }}
                      </div>
                      <div class="tag_one px-10 py-5 mr-10">
                        {{
                          item.year
                        }}
                      </div>
                      <div class="tag_one px-10 py-5 mr-10">
                        {{
                          originSubjectList.filter(
                            (sitem) => sitem.subjectId == item.subjectId
                          )[0]?.subjectName
                        }}
                      </div>
                    </div>
                    <div class="flex Flexalign paper_create mt-15">
                      <div>{{ $Moment(item.createTime).format("MM-DD") }}发布</div>
                      <div class="ml-30">浏览量：{{ item.viewCount }}</div>
                      <div class="ml-30">下载量：{{ item.downloadCount }}</div>
                      <div class="ml-30">创建人：{{ item.createByName }}</div>
                    </div>
                  </div>
                  <div class="paper_difficult ml-50 flex flexcolumn FlexEnd">
                    <el-rate v-model="item.difficulty" disabled :max="7" size="large" />
                    <div class="btn_start cursor_pointer">
                      {{ item.feeType == 1 ? '免费' : `￥${item.price}` }}
                    </div>
                    <div class="paper_price mt-5 cursor_pointer" @click.stop="showAnalysis(item)">
                      试卷分析
                    </div>
                  </div>
                </div>
                <div class="pagination_box mar_top_20 flex FlexjustifyEnd" v-if="listTotal > listParams.pageSize">
                  <el-pagination background layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40]"
                    :total="listTotal" v-model:page-size="listParams.pageSize" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" />
                </div>
              </div>
            </div>
            <div v-else>
              <moe-empty url="moe_empty_bg_img.png" emptyText="暂无试卷"></moe-empty>
            </div>
          </div>
        </div>
      </div>
    </div>
    <randomPaper ref="randomPaper" v-else-if="selectPaperTypeTab == 2"></randomPaper>
    <examinationAnalysis ref="examinationAnalysis"></examinationAnalysis>
  </moe-page>
</template>

<script>
import { mapState } from "vuex";
import examinationAnalysis from "@/components/popup/examinationAnalysis.vue";
import randomPaper from "@/components/examinationPaper/randomPaper.vue";
export default {
  name: "GjkcH5Index",
  computed: {
    ...mapState({
      originSubjectList: (state) => state.filter.subjectList,
      stageList: (state) => state.filter.stageList,
    }),
  },
  components: {
    examinationAnalysis,
    randomPaper
  },

  data() {
    return {
      paperTypeTabList: [
        { label: "备考专区", value: 1 },
        { label: "智能组卷", value: 2 },
      ],
      selectPaperTypeTab: 1,
      educationData: [],
      selectEducation: "",
      paperTypeList: [
        { label: "不限", value: "" },
        { label: "免费", value: 1 },
        { label: "付费", value: 2 },
      ],
      highlightPath: "",
      currentSelectedNodeId: null,
      difficultOptions: [
        { label: "全部", value: "" },
        { label: "一星", value: 1 },
        { label: "二星", value: 2 },
        { label: "三星", value: 3 },
        { label: "四星", value: 4 },
        { label: "五星", value: 5 },
        { label: "六星", value: 6 },
        { label: "七星", value: 7 },
      ],
      difficultValue: "",
      testPaperList: [],
      listParams: {
        year: '',
        feeType: "",
        stageId: "",
        gradeId: "",
        subjectId: "",
        difficulty: "",
        phaseId: '',
        roundId: '',
        page: 1,
        pageSize: 10,
        sort: 1,
        paperTypeId: ''
      },
      subjectList: [],
      topSelectedMenu: "",
      yearOptions: [],
      planOptions: [],
      phaseOptions: [],
      termList: [],
      listTotal: 0,
      // 滚动状态
      // isPaperListScrollable: false,
      // filterHeight: 0,
      // scrollContainer: null
    };
  },

  mounted() {
    this.topSelectedMenu = this.$Jump.getUrlParams(
      window.location.hash.split("?")[1]
    ).topSelectedMenu;
    this.$refs.moeTop.topSelectedMenu = this.topSelectedMenu;
    this.gradeList = this.$store.state.filter.gradeList;
    this.getExamPaperType();
    this.handleGradeList();
    this.getSubjectList();
    this.getYearOptions();
    this.getRoundDict();
    this.getPhaseList();

    // 初始化滚动监听
    // this.$nextTick(() => {
    //   this.initScrollListener();
    //   window.addEventListener('resize', this.handleResize);
    // });
  },

  beforeUnmount() {
    // if (this.scrollContainer) {
    //   this.scrollContainer.removeEventListener('scroll', this.handleScroll);
    // }
    // window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    // 试卷分析
    showAnalysis(info) {
      this.$refs.examinationAnalysis.initData(info.paperId);
    },

    getExamPaperType() {
      this.$Api.examination.getExamPaperType().then(res => {
        this.educationData = [{ label: '全部', value: '' }]
        res.data.data.forEach(item => {
          this.educationData.push({ label: item.paperTypeName, value: item.paperTypeId })
        })
      }).catch(() => { })
    },

    changeFilter(value) {
      this.listParams.sort = value;
      this.getExaminationList();
    },

    handleSizeChange() {
      this.getExaminationList();
    },

    handleCurrentChange(value) {
      this.listParams.page = value;
      this.getExaminationList();
    },

    getRoundDict() {
      this.$Api.course.getRoundDict().then((res) => {
        this.planOptions = [{ label: '全部轮次', value: '' }];
        for (var key in res.data.data) {
          this.planOptions.push({ label: res.data.data[key], value: key });
        }
      }).catch(() => { });
    },

    getPhaseList() {
      this.$Api.course.getPhaseList().then((res) => {
        this.phaseOptions = [{ label: '全部阶段', value: '' }];
        for (var key in res.data.data) {
          this.phaseOptions.push({ label: res.data.data[key], value: key });
        }
      }).catch(() => { });
    },

    getYearOptions() {
      this.yearOptions = [];
      this.yearOptions.push({ label: '全部年份', value: '' });
      let nowYear = this.$Moment().format('YYYY');
      for (let i = 4; i--; i > 0) {
        this.yearOptions.push({
          label: `${nowYear - (3 - i)}年`,
          value: `${nowYear - (3 - i)}`
        })
      }
      this.yearOptions.push({ label: `更早以前`, value: 0 });
    },

    changeStage(stageId) {
      this.$Api.common.getTerm({ stageId: stageId }).then((res) => {
        this.termList = res.data.data;
        this.getSubjectList();
      }).catch(() => { });
    },

    selectStage(stageId) {
      this.listParams.stageId = stageId;
      if (stageId == "") {
        this.gradeList = this.$store.state.filter.gradeList;
      } else {
        this.gradeList = this.$store.state.filter.gradeList.filter(
          (item) => item.stageId == stageId
        );
      }
      this.changeStage(stageId);
    },

    selectGrade(value) {
      this.listParams.gradeId = value;
      this.getSubjectList();
    },

    selectPaperType(info) {
      this.listParams.feeType = info.value;
      this.getExaminationList();
    },

    changePaperType(info) {
      this.selectPaperTypeTab = info.value;
    },

    changeEducation(info) {
      this.selectEducation = info.value;
      this.listParams.paperTypeId = info.value;
      this.getExaminationList();
    },

    handleGradeList() {
      const stageMap = {};
      this.gradeList.forEach((item) => {
        if (!stageMap[item.stageId]) {
          stageMap[item.stageId] = {
            id: parseInt(item.stageId) + 1000,
            label: item.stageName,
            stageId: item.stageId,
            type: "stage",
            children: [],
          };
        }
        stageMap[item.stageId].children.push({
          id: parseInt(item.gradeId),
          label: item.gradeName,
          gradeId: item.gradeId,
          stageId: item.stageId,
          type: "grade",
        });
      });
    },

    handleNodeClick(data, node) {
      console.log("节点被点击:", data, node);
      if (this.currentSelectedNodeId === data.id) {
        this.cancelSelection();
        return;
      }
      this.currentSelectedNodeId = data.id;
      this.highlightPath = this.getNodePath(node);
      this.updateHighlight();
      this.loadTestPapers(data, node);
    },

    cancelSelection() {
      this.currentSelectedNodeId = null;
      this.highlightPath = [];
      this.listParams.stageId = "";
      this.listParams.gradeId = "";
      this.listParams.subjectId = "";
      this.updateHighlight();
      if (this.$refs.treeRef) {
        this.$refs.treeRef.setCurrentKey(null);
      }
      this.getSubjectList();
      this.getExaminationList();
    },

    getNodePath(node) {
      const path = [];
      let currentNode = node;
      while (currentNode) {
        path.unshift(currentNode.data.id);
        currentNode = currentNode.parent;
      }
      return path;
    },

    updateHighlight() {
      const allNodes = document.querySelectorAll(".el-tree-node");
      allNodes.forEach((node) => {
        node.classList.remove("highlight-path");
      });
      if (this.highlightPath.length > 0) {
        this.highlightPath.forEach((nodeId) => {
          const nodeElement = document.querySelector(`[data-node-id="${nodeId}"]`);
          if (nodeElement) {
            nodeElement.classList.add("highlight-path");
          }
        });
      }
    },

    isInPath(nodeId) {
      return this.highlightPath.includes(nodeId);
    },

    loadTestPapers(data) {
      let stageId = null;
      let gradeId = null;
      if (data.type === "stage") {
        stageId = data.stageId;
        gradeId = null;
      } else if (data.type === "grade") {
        stageId = data.stageId;
        gradeId = data.gradeId;
      }
      this.listParams.stageId = stageId;
      this.listParams.gradeId = gradeId;
      this.listParams.subjectId = "";
      this.getSubjectList();
      this.getExaminationList();
    },

    getSubjectList() {
      this.$Api.common.getSubject({ stageId: this.listParams.stageId }).then((res) => {
        this.subjectList = res.data.data;
        this.getExaminationList();
      }).catch(() => { });
    },

    selectSubject(subjectId) {
      this.listParams.subjectId = subjectId;
      this.getExaminationList();
    },

    getExaminationList() {
      this.$Api.examination.getExaminationList(this.listParams).then(res => {
        this.testPaperList = res.data.data?.list;
        this.listTotal = res.data.data.total ? Number(res.data.data.total) : 0;

        this.$nextTick(() => {
          if (this.scrollContainer) {
            this.scrollContainer.scrollTop = 0;
          }
          // this.updatePaperListScroll();
        });
      }).catch(() => { })
    },

    viewExamPaper(info) {
      this.href("/examPaperView", { paperDocumentId: info.paperDocumentId })
    },

    // 初始化滚动监听
    initScrollListener() {
      this.scrollContainer = this.$refs.rightScrollContainer;
      const filterRef = this.$refs.filterRef;

      if (!this.scrollContainer || !filterRef) return;

      this.filterHeight = filterRef.offsetHeight;
      this.scrollContainer.addEventListener('scroll', this.handleScroll);
    },

    // 处理滚动事件
    handleScroll() {
      if (!this.scrollContainer) return;

      const scrollTop = this.scrollContainer.scrollTop;
      const shouldBeScrollable = scrollTop > this.filterHeight - 20;

      if (shouldBeScrollable !== this.isPaperListScrollable) {
        this.isPaperListScrollable = shouldBeScrollable;
        this.updatePaperListScroll();
      }
    },

    // 更新试卷列表滚动状态
    updatePaperListScroll() {
      const paperListRef = this.$refs.paperListRef;
      const bottomRef = this.$refs.bottomRef;

      if (!paperListRef || !bottomRef) return;

      if (this.isPaperListScrollable) {
        // 给 right_bottom 设置固定高度，让 test_paper_list 内部滚动
        const sortTab = bottomRef.querySelector('.sort-tab');
        const sortTabHeight = sortTab?.offsetHeight || 0;
        const windowHeight = window.innerHeight;
        // const bottomRect = bottomRef.getBoundingClientRect();
        const topOffset = 120; // 顶部固定元素的高度

        // 计算可用的最大高度
        const availableHeight = windowHeight - topOffset - sortTabHeight - 20;

        bottomRef.style.position = 'relative';
        paperListRef.style.maxHeight = `${availableHeight}px`;
        paperListRef.style.overflowY = 'auto';
        paperListRef.style.paddingRight = '5px';
      } else {
        // 恢复正常状态
        paperListRef.style.maxHeight = '';
        paperListRef.style.overflowY = '';
        paperListRef.style.paddingRight = '';
      }
    },

    // 窗口大小变化时重新计算
    handleResize() {
      if (this.$refs.filterRef) {
        this.filterHeight = this.$refs.filterRef.offsetHeight;
      }
      if (this.isPaperListScrollable) {
        this.updatePaperListScroll();
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.paper_tab {
  width: 100%;
  background: #ffffff;
  height: 60px;

  .paper_tab_list {
    width: $pageMainWidth;
    margin: 0 auto;

    .paper_tab_one {
      position: relative;
      font-size: 16px;
      color: #606060;
    }

    .paper_tab_one_active {
      font-size: 18px;
      color: #303030;
    }

    .active_line {
      width: 75px;
      height: 8px;
      background: linear-gradient(180deg, rgba(19, 214, 170, 0) 0%, #13d6aa 100%);
      opacity: 0.6;
      position: absolute;
      bottom: 0;
    }
  }
}

.test_paper_content {
  width: 100%;
  background: #f3f3f3;
  padding-top: 20px;
  height: calc(100vh - 120px);
  box-sizing: border-box;
  overflow: hidden;

  .content {
    width: $pageMainWidth;
    margin: 0 auto;
    display: flex;
    gap: 20px;
    height: 100%;

    .content_left {
      width: 267px;
      height: 100%;
      background: #ffffff;
      border-radius: 10px;
      box-sizing: border-box;
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      overflow: hidden;

      .catalog_details {
        font-weight: 500;
        font-size: 16px;
        color: #111111;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        flex-shrink: 0;

        .catalog_details_icon {
          width: 22px;
          height: 22px;
        }
      }

      .tree_box {
        flex: 1;
        overflow-y: auto;
        padding: 15px 30px;

        &::-webkit-scrollbar {
          width: 4px;
        }

        &::-webkit-scrollbar-thumb {
          background: #ddd;
          border-radius: 2px;
        }

        .education_one {
          line-height: 30px;
          font-size: 16px;
          color: #303030;

          &.education_one_active {
            color: #13d6aa;
          }
        }
      }
    }

    .content_right {
      flex: 1;
      height: 100%;
      overflow-y: auto;
      min-width: 0;
      position: relative;

      &::-webkit-scrollbar {
        width: 6px;
      }

      &::-webkit-scrollbar-thumb {
        background: #ddd;
        border-radius: 3px;

        &:hover {
          background: #ccc;
        }
      }

      &::-webkit-scrollbar-track {
        background: #f5f5f5;
        border-radius: 3px;
      }

      .right_top {
        width: 100%;
        background: #ffffff;
        border-radius: 10px;
        box-sizing: border-box;

        :deep(.el-select__wrapper) {
          box-shadow: none;
          font-size: 16px;
        }

        .filter_label {
          width: 70px;
          font-size: 14px;
          color: #606060;
          flex-shrink: 0;
        }

        .filter_value,
        .area_info {
          font-size: 14px;
          color: #606060;
          transition: color 0.3s;

          &.text_active {
            color: #13d6aa;
          }

          &:hover {
            color: #13d6aa;
          }
        }
      }

      .right_bottom {
        width: 100%;
        background: #ffffff;
        border-radius: 10px;
        box-sizing: border-box;
        transition: all 0.3s;

        .sort-tab {
          position: sticky;
          top: 0;
          background-color: #fff;
          z-index: 10;
          padding-top: 20px;
          // 可选：增加底部阴影，提升层次感
          // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
        }

        .test_paper_list {
          transition: all 0.3s;

          &::-webkit-scrollbar {
            width: 6px;
          }

          &::-webkit-scrollbar-thumb {
            background: #ddd;
            border-radius: 3px;

            &:hover {
              background: #ccc;
            }
          }

          &::-webkit-scrollbar-track {
            background: #f5f5f5;
            border-radius: 3px;
          }

          .total_num {
            font-size: 14px;
            color: #909090;
          }

          .test_paper_one {
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
            transition: all 0.3s;
            padding: 10px 0;

            &:hover {
              border: 1px solid #13d6aa;
              margin: -1px;
              padding: 11px 9px;
              border-radius: 8px;

              .paper_info .paper_name {
                color: #13d6aa;
              }
            }

            .test_paper_cover_icon {
              width: 92px;
              height: 104px;
              flex-shrink: 0;
            }

            .paper_info {
              flex: 1;
              min-width: 0;
              height: 104px;

              .paper_name {
                width: 100%;
                font-weight: 500;
                color: #303030;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .paper_tag {
                .tag_one {
                  background: #eff1f4;
                  border-radius: 4px;
                  font-size: 11px;
                  color: #606060;
                }
              }

              .paper_create {
                font-size: 12px;
                color: #606060;
              }
            }

            .paper_difficult {
              width: 110px;
              flex-shrink: 0;

              .btn_start {
                width: 91px;
                height: 32px;
                background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
                border-radius: 8px;
                text-align: center;
                line-height: 32px;
                font-size: 14px;
                color: #ffffff;
              }

              .paper_price {
                font-size: 14px;
                color: #FF6619;
                font-weight: 500;
                width: 91px;
                text-align: center;
              }
            }
          }
        }

        .pagination_box {
          padding-top: 15px;
          border-top: 1px solid rgba(0, 0, 0, 0.05);
        }
      }
    }
  }
}

.mar_top_20 {
  margin-top: 20px;
}
</style>